var _path, _g, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageMembershipPremiumSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 45,
    viewBox: "0 0 43 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2024_25857",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 2,
    width: 35,
    height: 38
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4478 10.093L24.4449 3.79505C23.8219 3.40797 23.1214 3.1755 22.3948 3.07242C21.0971 2.8659 19.7218 3.09837 18.5542 3.79505L7.55097 10.093C5.70857 11.1512 4.59277 13.0866 4.59277 15.1774V27.8244C4.59277 28.547 4.72251 29.2697 5.00807 29.9407C5.47519 31.1799 6.35761 32.238 7.55133 32.9088L18.5546 39.2063C20.3709 40.2645 22.6289 40.2645 24.4452 39.2063L35.4481 32.9088C36.0968 32.5217 36.6419 32.0571 37.109 31.4895C37.9392 30.4572 38.4063 29.1666 38.4063 27.8244V15.1774C38.4063 13.087 37.2905 11.1512 35.4478 10.093Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2024_25857)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3.99805,
    y: -2.99597,
    width: 73.983,
    height: 73.9506,
    fill: "url(#paint0_linear_2024_25857)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.456 28V16.144H22.344C23.2187 16.144 24.0027 16.2613 24.696 16.496C25.4 16.7307 25.9547 17.12 26.36 17.664C26.776 18.1973 26.984 18.9333 26.984 19.872C26.984 20.768 26.776 21.5093 26.36 22.096C25.9547 22.672 25.4053 23.0987 24.712 23.376C24.0293 23.6533 23.2613 23.792 22.408 23.792H20.824V28H18.456ZM20.824 21.92H22.248C23.0587 21.92 23.6613 21.7493 24.056 21.408C24.4613 21.0667 24.664 20.5547 24.664 19.872C24.664 19.1893 24.4507 18.7147 24.024 18.448C23.608 18.1707 22.9893 18.032 22.168 18.032H20.824V21.92Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2024_25857",
    x1: 11.4482,
    y1: -2.99597,
    x2: 54.5106,
    y2: 70.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6421"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7C1B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageMembershipPremiumSmall);
export default __webpack_public_path__ + "static/media/image__membership-premium--small.f10c657ec7483e9f88fa556c3cef251e.svg";
export { ForwardRef as ReactComponent };